import { Koi } from '@ksyos/koi';
import { getTextAreaStringSchema } from './utils/getTextAreaStringSchema';

export interface IAddress {
    city?: string | null;
    country?: string | null;
    houseLetter?: string | null;
    houseNumber?: string | null;
    houseNumberSuffix?: string | null;
    state?: string | null;
    street?: string | null;
    zip?: string | null;
}

export const addressValidationDraftSchema = Koi.object({
    city: getTextAreaStringSchema(true, 255),
    country: getTextAreaStringSchema(true, 255),
    houseLetter: Koi.string().max(1).allow(null),
    houseNumber: getTextAreaStringSchema(true, 255),
    houseNumberSuffix: getTextAreaStringSchema(true, 255),
    street: getTextAreaStringSchema(true, 255),
    zip: Koi.string()
        .max(255)
        .when('country', {
            is: 'NL',
            then: Koi.string().zipCodeNL(),
        })
        .allow(null),
});

export const addressValidationFinalSchema = Koi.object({
    city: getTextAreaStringSchema(false, 255),
    country: getTextAreaStringSchema(false, 255),
    houseLetter: Koi.string().max(1).allow(null),
    houseNumber: getTextAreaStringSchema(false, 255),
    houseNumberSuffix: getTextAreaStringSchema(true, 255),
    street: getTextAreaStringSchema(false, 255),
    zip: Koi.string().max(255).when('country', {
        is: 'NL',
        then: Koi.string().zipCodeNL(),
    }),
});

export const initialAddress: IAddress = {
    city: null,
    country: 'NL',
    houseLetter: null,
    houseNumber: null,
    houseNumberSuffix: null,
    state: null,
    street: null,
    zip: null,
};
